/* ----------------------------------------
カスタムJS
---------------------------------------- */

/* 
  即時関数内で実行することにより、他のスクリプトに影響を与えない。
*/

// 即時関数
(function(){
  
  /**
   * loadScript
   * 
   * 外部cdnのライブラリを読み込み、callback関数を実行する
   * @param {String} url 読み込む外部ライブラリのcdnのurl
   * @param {Function} callback 読み込み完了後、実行する関数
   * @return {None} 
   */
  var loadScript = function(urls, callback){

    // 先頭行を処理
    // console.log(urls[0] + 'の処理を行います。');

    // 読み込むスクリプトファイルの場所
    url = urls[0];

    // 先頭行を削除
    urls.shift();

    // script要素の生成
    var script = document.createElement("script");
    script.type = "text/javascript";
    
    // 読み込み完了後のコールバック呼び出し実装
    if (script.readyState){   // ----- IE用処理
      script.onreadystatechange = function(){
        if (script.readyState == "loaded" || script.readyState == "complete"){
          script.onreadystatechange = null;

          // urlsが残っていれば、再起呼び出しする。
          if(urls.length >= 1){
            loadScript(urls,callback);
          }else{
            callback();
          }
        }
      };
    } else {  // ----- IE以外のブラウザ用の処理
      script.onload = function(){

        // urlsが残っていれば、再起呼び出しする。
        if(urls.length >= 1){
          loadScript(urls,callback);
        }else{
          callback();
        }
      };
    }

    // script要素をページに組み込む
    script.src = url;
    document.getElementsByTagName("head")[0].appendChild(script);    
  };
  
  /**
   * myAppJavaScript
   * 
   * 外部ライブラリ読み込み後に適用するスクリプト
   * @param {Obj} $ jQueryオブジェクト
   * @return {None} 
   */
  var myAppJavaScript = function($){

    console.log('custom.js start');

    // ここからjqueryを使ったスクリプトを記載する。

    // カートページ初期化
    initCartPage($);

    // コレクションページ初期化
    initCollectionPage($);

    // トップに戻るボタン初期化
    initBtnToTop($);

  };

  // すべての外部ライブラリを読み込んで、最後に関数myAppJavaScriptを実行する
  loadScript(lib,function(){

    // $とjQueryを解放しつつ、関数myAppJavaScriptにjQueryオブジェクトを渡す
    jQueryLatest = jQuery.noConflict(true);
    myAppJavaScript(jQueryLatest);
  });

  /**
  * カートページ初期化
  * （１）「ご利用方法」と「職種」と「その他(入力)」と「見積書発行」が入力されているか、バリデーションする
  * @return none
  */
  const initCartPage = function($){

    // bodyにbodyCartクラスがなければ、なにもしない
    if( !$('body').hasClass('bodyCart') ){
      return false;
    }

    // 職種で「その他」を選ぶと、「その他(入力)」が表示される。他を選ぶと消える
    $('select#occupation').on('change', function(){
      if( $(this).val() == 'その他' ){  // その他だった場合
        $('[data-js-otherinput]').show().find('input').attr('required','required');
      }else{  // その他以外だった場合
        $('[data-js-otherinput]').hide().find('input').val('').removeAttr('required');
      }
    });

    const varidate = function(){
      let productUse = $('select#productUse').val();
      let occupation = $('select#occupation').val();
      let occupationMore = $('input#occupation_more').val();
      let estimate = $('select#estimate').val();

      if(productUse === '' || occupation === '' || estimate === ''){
        // バリデーション NG
        $('button#checkout').prop('disabled', true);
        // 追加チェックアウトをdisableにする
        $('.cart__dynamic-checkout-buttons.additional-checkout-buttons').addClass('c-disable');
      }else if( occupation == 'その他' && occupationMore == '' ){
        // バリデーション NG
        $('button#checkout').prop('disabled', true);
        // 追加チェックアウトをdisableにする
        $('.cart__dynamic-checkout-buttons.additional-checkout-buttons').addClass('c-disable');
      }else{
        // バリデーション OK
        $('button#checkout').prop('disabled', false);
        // 追加チェックアウトをableにする
        $('.cart__dynamic-checkout-buttons.additional-checkout-buttons').removeClass('c-disable');
      }
    }

    // 初回バリデーション
    varidate();

    // 追加チェックアウトボタンに、disableBtnを追加
    $('.cart__dynamic-checkout-buttons.additional-checkout-buttons').append('<a href="" class="c-disableBtn"></a>');

    // disableボタンにalert表示機能を追加する
    $('.c-disableBtn').on('click',function(e){
      e.preventDefault();
      if( $('select#occupation').val() == 'その他' && $('input#occupation_more').val() == '' ){
        alert('「ご利用方法」と「職種」と「その他(入力)」と「見積書発行」は必須入力です。');
      }else{
        alert('「ご利用方法」と「職種」と「見積書発行」は必須入力です。');
      }
    })

    // 「ご利用方法」と「職種」と「その他(入力)」と「見積書発行」が変更されたらバリデーションを実行する
    $('select#productUse, select#occupation, input#occupation_more, select#estimate').on('change',function(){
      varidate();
    })
  }

  /**
  * コレクションページ初期化
  * （１）「カートに追加する」ボタンを追加する
  * （２）説明エリアにswiperを追加
  * @return none
  */
  const initCollectionPage = function($){

    // bodyにbodyCollectionクラスがなければ、なにもしない
    if( !$('body').hasClass('bodyCollection') ){
      return false;
    }

    // 「カートに追加する」ボタンを押したときの処理
    $('[js-add-to-cart]').on('click',async function(){

      // ボタンがloadingのときはなにもしない
      if($(this).hasClass('-loading')){
        return false;
      }

      let formData = {
        items: [
          {
            id: $(this).attr('js-add-to-cart'),
            quantity: 1,
          },
        ],
      };

      // ボタンをローディング中に変更
      $(this).addClass('-loading').prop('disabled',true);

      // カート追加処理
      await fetch("/cart/add", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(formData),
      })
      .then(()=>{
        // ヘッダのカート疑似更新
        if( $('header .icon-cart-empty').length ){
          //カートが空の場合
          $('header .icon-cart-empty').removeClass('icon-cart-empty').addClass('icon-cart')
            .next().after('<div class="cart-count-bubble"><span aria-hidden="true">1</span><span class="visually-hidden">1個のアイテム</span></div>');
        }else{
          let num = Number( $('header .cart-count-bubble').find('[aria-hidden="true"]').html() );
          $('header .cart-count-bubble').find('[aria-hidden="true"]').html(num + 1)
            .next().html(num + 1 + '個のアイテム');
        }
        alert('カートに追加しました。');
      })
      .catch((error) => {
        console.error("Error:", error)
      });

      // ボタンのローディング解除
      $(this).removeClass('-loading').prop('disabled',false);
    });

    // 説明エリアのswiper初期化
    if( $('.info-swiper > .swiper-wrapper > .swiper-slide').length >= 2 ){

      // 自動再生するかどうか
      let ap = false;
      if( IS_INFOSWIPER_AUTO ){
        ap =  {
          delay: 8000,
        }
      }

      const info_swiper = new Swiper('.info-swiper', {
        loop: true,
        autoplay: ap,
        pagination: {
          el: '.info-swiper > .swiper-pagination',
        },
        navigation: {
          nextEl: '.info-swiper > .swiper-button-next',
          prevEl: '.info-swiper > .swiper-button-prev',
        },
      });
    }

    // サムネイルエリアのswiper初期化
    $('.thumb-swiper').each(function(){

      if( $(this).find('.swiper-wrapper > .swiper-slide').length >= 2 ){

        // 自動再生するかどうか
        let ap = false;
        if( IS_INFOSWIPER_AUTO ){
          ap =  {
            delay: 8000,
          }
        }

        // idの取得
        let id = $(this).closest('.product-item').attr('id');

        new Swiper('#' + id + ' .thumb-swiper', {
          loop: true,
          autoplay: ap,
          // autoHeight: true,
          pagination: {
            el: '#' + id + ' .thumb-swiper > .swiper-pagination',
          },
          navigation: {
            nextEl: '#' + id + ' .thumb-swiper > .swiper-button-next',
            prevEl: '#' + id + ' .thumb-swiper > .swiper-button-prev',
          },
        });
      }
    })

    // 並び替えを変更したときに、ページ遷移するように修正
    $('#main-collection-filters select[name="sort_by"]').on('change', function(){
      console.log('abc');

      // 遷移
      let url = location.pathname + '?sort_by=' + $(this).val()
      window.location.href = url;
    })

  }

  /**
  * トップに戻るボタン初期化
  * @return none
  */
 const initBtnToTop = function($){

  // （１）ボタンを押したときの処理
  $('#btnToTop').on('click',function(e){
    e.preventDefault();
    $("html, body").animate({scrollTop:0}, 500, "swing");
  });

  // （２）スクロール時の処理
  let timerId = null;
  $(window).on('load resize scroll', function(){
    // 間引き処理
    clearTimeout(timerId); 
    timerId = setTimeout(function(){

      // スクロール位置に応じて、ボタンを表示/非表示にする
      if( $(window).scrollTop() == 0 ){
        $('#btnToTop').fadeOut(100);
      }else{
        $('#btnToTop').fadeIn(100);
      }
    }, 5);
  });
 }

})();